import React from 'react';
import styled from 'styled-components';
import { Theme, Caption } from '@routific/hive';

interface TooltipProps {
  used: string;
  total: string;
  overCap?: boolean;
}

const TableElement = styled.table`
min-width: 60px;
  td {
    &:first-child {
      padding-right: ${Theme.Spacing.lgSpacing}
    }
  }
`;

const DarkTooltipTable: React.FC<TooltipProps> = ({ used, total, overCap }) => (
  <TableElement cellSpacing={0} cellPadding={0}>
    <tbody>
      <tr data-testid={`row-${overCap ? 'warning' : 'normal'}`}>
        <td>
          <Caption {...(overCap ? { type: 'warning' } : { onDark: true })}>
            {used}
          </Caption>
          <Caption onDark>{`\u00A0/ ${total}`}</Caption>
        </td>
      </tr>
    </tbody>
  </TableElement>
);

export default DarkTooltipTable;
